import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Services API
export const servicesAPI = {
  getAll: () => api.get('/services'),
  getById: (id) => api.get(`/services/${id}`),
  create: (data) => api.post('/services', data),
  update: (id, data) => api.put(`/services/${id}`, data),
  delete: (id) => api.delete(`/services/${id}`),
};

// Tariffs API
export const tariffsAPI = {
  getAll: () => api.get('/tariffs'),
  getByCountryYear: (country, year) => api.get(`/tariffs/${country}/${year}`),
  create: (data) => api.post('/tariffs', data),
  update: (id, data) => api.put(`/tariffs/${id}`, data),
  delete: (id) => api.delete(`/tariffs/${id}`),
};

// Calculator API
export const calculatorAPI = {
  calculate: (data) => api.post('/calculator', data),
};

// Orders API
export const ordersAPI = {
  create: (data) => api.post('/orders', data),
  getAll: () => api.get('/orders'),
  getById: (id) => api.get(`/orders/${id}`),
  getReceipt: (id) => `${API_BASE}/orders/${id}/receipt`,
  getAgreement: (id) => `${API_BASE}/orders/${id}/agreement`,
};

// Countries API
export const countriesAPI = {
  getAll: () => api.get('/countries'),
  create: (data) => api.post('/countries', data),
  update: (id, data) => api.put(`/countries/${id}`, data),
  delete: (id) => api.delete(`/countries/${id}`),
};

// Dashboard API
export const dashboardAPI = {
  get: () => api.get('/dashboard'),
};

// Knowledge API
export const knowledgeAPI = {
  checkAccess: () => api.get('/knowledge/access-check'),
  getAll: () => api.get('/knowledge'),
  getById: (id) => api.get(`/knowledge/${id}`),
  getAttachment: (id, token) => `${API_BASE}/knowledge/${id}/attachment?token=${token}`,
};

// Admin API
export const adminAPI = {
  getCompanies: () => api.get('/admin/companies'),
  getStats: () => api.get('/admin/stats'),
  exportOrders: () => `${API_BASE}/admin/orders/export`,
};

// Settings API
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

// Seed API (for development)
export const seedAPI = {
  seed: () => api.post('/seed'),
};

export default api;
